import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { LogoFull } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput, scorePassword } from "@/components/PasswordInput";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const token = sp.get("token");
  const [pwd, setPwd] = useState({ new_password: "", confirm: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.new_password !== pwd.confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    if (scorePassword(pwd.new_password) < 3) { toast.error("Mot de passe trop faible : choisissez au moins un niveau « Moyen »."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd.new_password });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    setLoading(false);
  };

  return (
    <div className="section-sand min-h-[80vh] flex items-center justify-center py-16 px-4">
      <div className="bg-white rounded-3xl shadow-card border border-border p-8 sm:p-10 max-w-md w-full">
        <div className="flex justify-center mb-6"><LogoFull /></div>
        <h1 className="font-heading font-extrabold text-2xl text-ink text-center">Nouveau mot de passe</h1>
        {!token ? (
          <p className="text-center text-destructive font-body mt-4">Lien invalide. <Link to="/forgot-password" className="text-emeraude font-bold hover:underline">Refaire une demande</Link></p>
        ) : done ? (
          <div className="mt-6 text-center">
            <div className="w-16 h-16 rounded-full bg-emeraude/15 flex items-center justify-center mx-auto mb-4"><CheckCircle2 className="w-8 h-8 text-emeraude" /></div>
            <p className="text-muted2 font-body">Mot de passe réinitialisé ! Redirection vers la connexion...</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <PasswordInput data-testid="reset-new" required showStrength placeholder="Nouveau mot de passe" value={pwd.new_password} onChange={(e) => setPwd({ ...pwd, new_password: e.target.value })} className="h-12 rounded-xl bg-sand" />
            <PasswordInput data-testid="reset-confirm" required placeholder="Confirmer le mot de passe" value={pwd.confirm} onChange={(e) => setPwd({ ...pwd, confirm: e.target.value })} className="h-12 rounded-xl bg-sand" />
            <Button type="submit" data-testid="reset-submit" disabled={loading} className="w-full h-12 rounded-full bg-emeraude hover:bg-emeraude-dark font-bold">{loading ? "..." : "Réinitialiser"}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
